export default {"src":"/_next/static/media/lines.f7eb4993.svg","height":177,"width":1480,"blurWidth":0,"blurHeight":0};